import React, { useState } from "react";
import { ReactComponent as AddIcon } from "../../assets/images/icons/AddCircle.svg";
import AddSection from "./AddSection";
import GeneralInfoIcon from "../../assets/images/icons/GeneralInfoIcon";
import AddressIcon from "../../assets/images/icons/AddressIcon";
import ContactIcon from "../../assets/images/icons/ContactIcon";
import FinancialDetailsIcon from "../../assets/images/icons/FinancialDetailsIcon";
import AttachmentsIcon from "../../assets/images/icons/AttachmentsIcon";
import NotesIcon from "../../assets/images/icons/NotesIcon";

const VendorSideBar = ({ setActiveTab, activeTab, isDisable }) => {
  const [isOpenAddSection, setIsOpenAddSection] = useState(false);

  const items = [
    { key: "general", label: "General Info", icon: <GeneralInfoIcon active={activeTab === "general"} /> },
    { key: "address", label: "Address", icon: <AddressIcon active={activeTab === "address"} /> },
    { key: "contact", label: "Contact", icon: <ContactIcon active={activeTab === "contact"} /> },
    { key: "financial", label: "Financial Details", icon: <FinancialDetailsIcon active={activeTab === "financial"} /> },
    // { key: "attachments", label: "Attachments", icon: <AttachmentsIcon active={activeTab === "attachments"} /> },
    // { key: "notes", label: "Notes", icon: <NotesIcon active={activeTab === "notes"} /> },
  ];

  const handleAddSection = () => {
    setIsOpenAddSection(true);
  };

  const handleAddSectionClose = () => {
    setIsOpenAddSection(false);
  };

  const staticsAddSection = [
    { key: "addSection", label: "Section 1", icon: <GeneralInfoIcon active={activeTab === "addSection"} /> },
    // { key: "section2", label: "Section 2", icon: <GeneralInfoIcon active={activeTab === "addSection2"} /> },
    // { key: "section3", label: "Section 3", icon: <GeneralInfoIcon active={activeTab === "addSection3"} /> },
  ];

  return (
    <div className="p-1 flex flex-col justify-between h-full bg-[#FAFAFA]">
      <div>
        <ul className=" space-y-3 ">
          {items.map((item, index) => {
            const isItemActive = activeTab === item.key;
            const isDisabled = isDisable && index !== 0;
            return (
              <li
                key={item.key}
                onClick={() => {
                  if (!isDisabled) setActiveTab(item.key);
                }}
                className={`flex items-center gap-2 px-2 py-1 rounded-md 
          ${isItemActive ? "bg-[#F0F0F0]" : ""}                        
          ${isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:bg-[#F5F5F5]"} 
        `}
              >
                <span>{item.icon}</span>
                <span
                  className={`text-14 font-400 ${
                    activeTab === item.key ? "text-[#1D4469] text-16 font-500" : "text-[#888]"
                  }`}
                >
                  {item.label}
                </span>
              </li>
            );
          })}
        </ul>
        {false && (
          <ul className=" space-y-3 mt-5">
            {staticsAddSection.map((item) => (
              <li
                key={item.key}
                onClick={() => setActiveTab(item.key)}
                className={`flex items-center gap-2 cursor-pointer px-2 py-1 rounded-md ${
                  activeTab === item.key ? "bg-[#F0F0F0]" : "hover:bg-[]"
                }`}
              >
                <span>{item.icon}</span>
                <span
                  className={`text-sm font-medium ${
                    activeTab === item.key ? "text-[#1D4469] text-md font-medium" : "text-[#888]"
                  }`}
                >
                  {item.label}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
      {false && (
        <div className="flex items-center justify-center bg-[#F0F0F0] border border-[#D2DAE1] rounded-md mb-2 w-full">
          <button
            onClick={handleAddSection}
            className="p-2 text-12 text-[#1D4469] capitalize font-500 flex items-center gap-1 "
          >
            <AddIcon /> Add Section
          </button>
        </div>
      )}
      {isOpenAddSection && <AddSection open={isOpenAddSection} onClose={handleAddSectionClose} />}
    </div>
  );
};

export default VendorSideBar;
